"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInvoiceOrQuoteID = exports.timeSince = exports.clean = exports.round = exports.formatDate = exports.prettifyPhone = exports.formatCurrency = exports.PROVINCES = exports.STATES = exports.setObjectProperties = exports.getSID = exports.isValidEmail = exports.isValidPhone = exports.stackTrace = void 0;
const date_fns_1 = require("date-fns");
const index_1 = require("../index");
function stackTrace() {
    var err = new Error();
    return err.stack;
}
exports.stackTrace = stackTrace;
function isValidPhone(phoneNumber) {
    let res = '';
    if (phoneNumber) {
        let phone = phoneNumber.replace(/\D/g, '');
        if (phone && (phone.length === 10 || phone.length === 7)) {
            res = phone;
        }
    }
    return res;
}
exports.isValidPhone = isValidPhone;
function isValidEmail(email) {
    if (email) {
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (re.test(email)) {
            return true;
        }
    }
    return false;
}
exports.isValidEmail = isValidEmail;
function getSID(length, date) {
    let id = '';
    let aChars = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'y', 'x', 'z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
    length = (length && length > 0) ? length : 6;
    for (let i = 0; i < length; i++) {
        id += aChars[Math.floor(Math.random() * aChars.length)];
    }
    if (date) {
        return `${Date.now()}-${id}`;
    }
    else {
        return id;
    }
}
exports.getSID = getSID;
/**
 * This sets properties on a Base object.
 * @param obj - the object instance
 * @param data - the data used to populate object properties. This can be a plain, data map or a DocumentSnapshot from firestore
 * @param olm - the object loader map appropriate for the context.
 */
function setObjectProperties(obj, data, olm, klass) {
    if (data !== 'PROTO' && klass) {
        obj._p = Reflect.construct(klass, ['PROTO']);
    }
    if (data) {
        if (data.ref && data.data instanceof Function) {
            obj._docRef = data.ref;
            let id = data.id;
            obj._exists = data.exists instanceof Function ? data.exists() : data.exists || false;
            data = data.data() || {};
            data.id = id;
        }
        else if (data._docRef) {
            obj._docRef = data._docRef;
            obj._exists = data.exists instanceof Function ? data.exists() : data.exists || false;
        }
        if (data) {
            olm = olm || index_1.olm;
            Object.keys(obj).forEach(p => {
                if (data[p] !== undefined) {
                    if (obj[p] instanceof index_1.DimensionArray) {
                        obj[p] = new index_1.DimensionArray(data.dimensions);
                    }
                    else if (obj[p] instanceof index_1.ChildArray) {
                        obj[p] = new index_1.ChildArray();
                        if (data[p]?.length) {
                            obj[p] = data[p].map(i => {
                                if (i._type && olm) {
                                    return olm[i._type](i, olm);
                                }
                                else {
                                    return i;
                                }
                            });
                        }
                    }
                    else {
                        obj[p] = data[p];
                        if (obj[p] instanceof Array) {
                            obj[p] = obj[p].map(i => {
                                if (i._type && olm[i._type]) {
                                    i = olm[i._type](i, olm);
                                }
                                else if (i._type && i.id) {
                                    // let err = new Error();
                                    // err.stack
                                    console.warn(`No type loader for type ${i._type} on ${obj._docRef?.path || obj.id}`);
                                }
                                return i;
                            });
                        }
                        if (obj[p] && obj[p]._type && olm) {
                            if (olm[obj[p]._type]) {
                                obj[p] = olm[obj[p]._type](obj[p], olm);
                            }
                            else if (obj[p]._type && obj[p].id) {
                                // let err = new Error();
                                // err.stack
                                console.warn(`No type loader for type ${obj[p]._type} on ${obj._docRef?.path || obj.id}`);
                            }
                        }
                    }
                }
            });
        }
    }
    return data;
}
exports.setObjectProperties = setObjectProperties;
exports.STATES = [
    { value: 'AK', label: 'Alaska', alt: ['Alas,'] },
    { value: 'AL', label: 'Alabama', alt: ['Ala'] },
    { value: 'AR', label: 'Arkansas', alt: ['Ark', 'Ar'] },
    { value: 'AS', label: 'American Samoa' },
    { value: 'AZ', label: 'Arizona', alt: ['Ariz'] },
    { value: 'CA', label: 'California', alt: ['Cal', 'Calif', 'Cali', 'Calf'] },
    { value: 'CO', label: 'Colorado', alt: ['Colo', 'Col'] },
    { value: 'CT', label: 'Connecticut', alt: ['Conn'] },
    { value: 'DC', label: 'District of Columbia', alt: [] },
    { value: 'DE', label: 'Delaware', alt: ['Del'] },
    { value: 'FL', label: 'Florida', alt: ['Fla'] },
    { value: 'GA', label: 'Georgia', alt: [] },
    { value: 'GU', label: 'Guam' },
    { value: 'HI', label: 'Hawaii', alt: ['Haw', 'Hawai\'i', 'Maui', 'O\'ahu', 'Hawai‘i', 'O‘ahu', 'Oahu', 'Kauai', 'Kaua\'i'] },
    { value: 'IA', label: 'Iowa', alt: ['Iow'] },
    { value: 'ID', label: 'Idaho', alt: ['Id'] },
    { value: 'IL', label: 'Illinois', alt: ['Ill', 'Illl'] },
    { value: 'IN', label: 'Indiana', alt: ['Ind'] },
    { value: 'KS', label: 'Kansas', alt: ['Kans', 'Kan'] },
    { value: 'KY', label: 'Kentucky', alt: ['Ken'] },
    { value: 'LA', label: 'Louisiana', alt: ['Lou'] },
    { value: 'MA', label: 'Massachusetts', alt: ['Mass'] },
    { value: 'MD', label: 'Maryland', alt: [] },
    { value: 'ME', label: 'Maine', alt: [] },
    { value: 'MI', label: 'Michigan', alt: ['Mich'] },
    { value: 'MN', label: 'Minnesota', alt: ['Minn'] },
    { value: 'MO', label: 'Missouri', alt: [] },
    { value: 'MS', label: 'Mississippi', alt: ['Miss'] },
    { value: 'MT', label: 'Montana', alt: ['Mont'] },
    { value: 'NC', label: 'North Carolina', alt: [] },
    { value: 'ND', label: 'North Dakota', alt: [] },
    { value: 'NE', label: 'Nebraska', alt: ['Neb'] },
    { value: 'NH', label: 'New Hampshire', alt: [] },
    { value: 'NJ', label: 'New Jersey', alt: [] },
    { value: 'NM', label: 'New Mexico', alt: [] },
    { value: 'NV', label: 'Nevada', alt: ['Nev'] },
    { value: 'NY', label: 'New York', alt: [] },
    { value: 'OH', label: 'Ohio', alt: ['Ohio'] },
    { value: 'OK', label: 'Oklahoma', alt: ['Okla'] },
    { value: 'OR', label: 'Oregon', alt: ['Ore'] },
    { value: 'PA', label: 'Pennsylvania', alt: ['Penn'] },
    { value: 'PR', label: 'Puerto Rico', alt: [] },
    { value: 'RI', label: 'Rhode Island', alt: [] },
    { value: 'SC', label: 'South Carolina', alt: [] },
    { value: 'SD', label: 'South Dakota', alt: [] },
    { value: 'TN', label: 'Tennessee', alt: ['Tenn'] },
    { value: 'TX', label: 'Texas', alt: ['Tex'] },
    { value: 'UT', label: 'Utah', alt: [] },
    { value: 'VA', label: 'Virginia', alt: ['Virg'] },
    { value: 'VI', label: 'Virgin Islands', alt: [] },
    { value: 'VT', label: 'Vermont', alt: [] },
    { value: 'WA', label: 'Washington', alt: ['Wash'] },
    { value: 'WI', label: 'Wisconsin', alt: ['Wis', 'Wisc'] },
    { value: 'WV', label: 'West Virginia', alt: ['WVa'] },
    { value: 'WY', label: 'Wyoming', alt: ['Wyo'] }
];
exports.PROVINCES = [
    { value: 'AB', label: 'Alberta', country: 'CA', alt: ['Alberta (Canada)'] },
    { value: 'BC', label: 'British Columbia', country: 'CA', alt: ['B.C.'] },
    { value: 'MB', label: 'Manitoba', country: 'CA' },
    { value: 'NS', label: 'Nova Scotia', country: 'CA' },
    { value: 'NB', label: 'New Brunswick', country: 'CA' },
    { value: 'NF', label: 'Newfoundland and Labrador', country: 'CA' },
    { value: 'NT', label: 'Northwest Territory', country: 'CA' },
    { value: 'NU', label: 'Nunavut', country: 'CA' },
    { value: 'ON', label: 'Ontario', country: 'CA', alt: ['Ont.', 'Ont. (Canada)'] },
    { value: 'PE', label: 'Prince Edward Island', country: 'CA' },
    { value: 'QC', label: 'Quebec', country: 'CA', alt: ['Québec', 'Que', 'Quebec City'] },
    { value: 'SK', label: 'Saskatchewan', country: 'CA' },
    { value: 'YT', label: 'Yukon Territory', country: 'CA' }
];
function formatCurrency(n) {
    if (n !== undefined && isNaN(n) === false) {
        let currencyFormatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
        });
        return currencyFormatter.format(n);
    }
    else {
        return '';
    }
}
exports.formatCurrency = formatCurrency;
function prettifyPhone(sNum) {
    if (sNum) {
        let aSupportedCountries = [
            { nPhone: 1, sCode: 'us', sName: 'United States', sFULL: '(\\+)?(1)(\\d{10})', sAREA: '(\\d{10})', sPrettify: '(\\d{3})(\\d{3})(\\d{4})' }
        ];
        sNum = sNum.toString();
        sNum = sNum.replace(/\D/g, '').replace(/ /g, '');
        for (let n = 0; n < aSupportedCountries.length; n++) {
            let hCountry = aSupportedCountries[n];
            if (sNum && sNum.match(new RegExp(hCountry.sFULL))) {
                sNum = sNum.substring(1);
            }
            else if (!sNum.match(new RegExp(hCountry.sAREA))) {
                sNum = null;
            }
            if (sNum) {
                let sPretty = sNum;
                let aMatches = sNum.match(new RegExp(hCountry.sPrettify));
                if (aMatches)
                    if (hCountry.sCode == 'us') {
                        sPretty = aMatches[1] + '-' + aMatches[2] + '-' + aMatches[3];
                        return sPretty;
                    }
            }
        }
    }
    else {
        sNum = '';
    }
    return sNum;
}
exports.prettifyPhone = prettifyPhone;
function formatDate(time, f) {
    if (time && time instanceof Date) {
        return (0, date_fns_1.format)(time, f || 'EEE, MMM do h:mm a');
    }
    else if (time) {
        return (0, date_fns_1.format)(new Date(time), f || 'EEE, MMM do h:mm a');
    }
    else {
        return '';
    }
}
exports.formatDate = formatDate;
function round(value, decimals) {
    // @ts-ignore
    return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
}
exports.round = round;
function clean(o, n) {
    n = n || 0;
    if (n < 3 && o && typeof o === 'object' && Object.keys(o) && Object.keys(o).length) {
        Object.keys(o).forEach((subprop) => {
            if (o[subprop] === undefined) {
                delete o[subprop];
            }
            else {
                o[subprop] = clean(o[subprop], n + 1);
            }
        });
    }
    return o;
}
exports.clean = clean;
function timeSince(date) {
    let seconds = Math.floor((Date.now() - date) / 1000);
    let divisors = [31536000, 2592000, 86400, 3600, 60, 1];
    let description = ["yr", "mon", "d", "h", "min", "sec"];
    let result = [];
    let interval = seconds;
    for (let i = 0; i < divisors.length; i++) {
        interval = Math.floor(seconds / divisors[i]);
        if (interval > 1 && !result.length) {
            result.push(interval + " " + description[i]);
        }
        seconds -= interval * divisors[i];
    }
    return result.join(" ");
}
exports.timeSince = timeSince;
const goodChars = [
    'C', 'D', 'E', 'G', 'H',
    'I', 'J', 'K', 'L', 'O',
    'Q', 'R', 'T', 'U', 'W',
    'X', 'Y', 'Z', 'c', 'd',
    'e', 'g', 'h', 'i', 'j',
    'k', 'l', 'o', 'q', 'r',
    't', 'u', 'w', 'x', 'y', 'z'
];
const allChars = ['2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'y', 'x', 'z'];
function getGoodLetters(n) {
    let id = '';
    n = (n && n > 0) ? n : 6;
    for (let i = 0; i < n; i++) {
        id += goodChars[Math.floor(Math.random() * goodChars.length)];
    }
    return id;
}
function getHourChar(hour) {
    hour = Number(hour);
    if (hour < 7) {
        return 'C';
    }
    else {
        let now = new Date().getTime();
        if (2 % now) {
            return goodChars[hour - 7];
        }
        else {
            return goodChars[hour - 7].toLowerCase();
        }
    }
}
function getMinuteChar(minute) {
    return allChars[Number(minute)];
}
function getInvoiceOrQuoteID(isQuote, date) {
    let now = date || new Date();
    return `${isQuote ? 'Q-' : ''}${(0, date_fns_1.format)(now, 'yyMMdd')}${getHourChar((0, date_fns_1.format)(now, 'H'))}${getMinuteChar((0, date_fns_1.format)(now, 'm'))}${getGoodLetters(2)}`;
}
exports.getInvoiceOrQuoteID = getInvoiceOrQuoteID;
